"use client"

import { isClient } from "@/lib/env-utils/env-utils"
import { useSearchParams } from "next/navigation"

export default function PreviewRefreshButton() {
    const searchParams = useSearchParams()
    const reReload = searchParams.get("reload")

    if (reReload == "true" && isClient) {
        const url = new URL(window.location.href)
        url.searchParams.delete("reload")
        setTimeout(() => {
            return (window.location.href = url.href)
        }, 2500)
    }

    function reloadPage() {
        return (window.location.href = `${window.location.href}?reload=true`)
    }

    return (
        <button
            onClick={reloadPage}
            className="fixed right-20 top-80 z-50 rounded-full bg-slate-400 bg-opacity-60 p-20 text-20 font-black text-white backdrop-blur-lg duration-300 hover:bg-opacity-80 hover:backdrop-blur-2xl"
        >
            Update
        </button>
    )
}
